import { ArrowForwardOutlined } from '@lichtblick/icons';
import { styled } from '@lichtblick/styled';
import { Colors, Spacing } from '@lichtblick/theme';

export const Container = styled.div`
  background: ${Colors.white};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: ${Spacing.Xs};
  padding: ${Spacing.Xs};
  width: 100%;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
export const BtnWrapper = styled.div`
  width: 75%;
`;
export const AppointmentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.Xxs};
`;
export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.Xs};
  padding: ${Spacing.Xxs};
  width: 100%;
`;

export const ArrowForwardOutlinedIcon = styled(ArrowForwardOutlined)`
  align-items: center;
  color: ${Colors.gray['50']};
  display: flex;
  height: 1rem;
  margin-right: ${Spacing.Xs};
  width: 1rem;
`;

export const BtnContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacing.Xs};
  width: 100%;
`;
